/**
 * Founder identity config — Phase 92 (site audit fix D3.3 / FIT).
 *
 * The audit's #1 trust gap: the site says "Designed by a swim instructor,
 * for swim instructors" but never names the founder. This config drives
 * the founder block in the marketing footer and on /about.
 *
 * Filled in by the owner (Jacob Siegel) — Feb 2026. Photo supplied by the
 * owner; text overlay removed and cropped square, served from
 * /public/founder-jacob.jpg.
 */
export const FOUNDER = {
    enabled: true,
    name: 'Jacob Siegel',
    photoUrl: '/founder-jacob.jpg',
    linkedinUrl: '',
    instagramUrl: 'https://www.instagram.com/superheroswim/',
    bio: 'Working swim instructor for 12+ years · Founder of Superhero Swim Academy & Superhero Swim University',
};
